<template>
  <section>
    <div class="form">
      <div class="inner">
        <form ref="loginForm" @submit="submit">
          <h4>Login</h4>
          
          <div>
            <div class="notification" v-if="showingExternalIdIncorrectCode">
              <Notification
                message="Incorrect login ID. Please try again."
                :icon="['fas', 'exclamation-circle']"
                type="error"
              />
            </div>

            <label for="loginExternalId">Login ID</label>
            <input
              ref="loginExternalId"
              type="text"
              id="loginExternalId"
              name="name"
              placeholder="Your login ID"
              v-model="externalId"
              required
            />
          </div>

          <button type="submit" :disabled="processing" aria-label="Login">
            <span class="spinner" v-if="processing">
              <fa-icon
                icon="spinner" 
                size="1x"
                :spin="true"
              />
            </span>
            Login
          </button>
        </form>
      </div>
    </div>
  </section>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';

import Notification from '@/components/Notification';

export default {
  name: 'Login',
  components: {
    Notification
  },
  data() {
    return {
      processing: false,
      showingExternalIdIncorrectCode: false
    }
  },
  computed: {
    ...mapGetters([
      'userByExternalId'
    ]),
    externalId: {
      get() {
        return this.$store.state.externalId;
      },
      set(value) {
        this.setExternalId(value);
      }
    }
  },
  methods: {
    ...mapMutations([
      'setExternalId'
    ]),
    ...mapActions([
      'loginUser'
    ]),
    async submit(e) {
      e.preventDefault();
      if(!this.$refs.loginForm.checkValidity() || this.processing) {
        return;
      }

      const user = this.userByExternalId(this.externalId);
      if (user) {
        this.showingExternalIdIncorrectCode = false;
        this.setExternalId(this.externalId);
        this.processing = true;
        await this.loginUser({});
        this.processing = false;
      } else {
        this.showingExternalIdIncorrectCode = true;
      }
    }
  },
  mounted() {
    this.$refs.loginExternalId && this.$refs.loginExternalId.focus();
  }
}
</script>

<style scoped lang="scss">
section {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10;
  background: rgba(255,255,255,1);
}

.form {
  display: table;
  width: 300px;
  height: 90%;
  margin: 0 auto;

  > .inner {
    display: table-cell;
    vertical-align: middle;
  }
}

form {
  background: #fff;
  padding: 16px;
  border-radius: 5px;
  box-shadow: 0 4px 16px rgba(60, 40, 40, 0.12);
}

.notification {
  margin: 12px 0 0 0;
}

h4 {
  margin: 0;
  font-size: 20px;
  line-height: 1;
}

label {
  display: block;
  color: rgba(47, 49, 56, 0.35);
  font-size: 12px;
  margin: 12px 0 2px;
}

input {
  display: block;
  background: #fff;
  border: 1px solid #c8cbd2;
  font-size: 16px;
  font-family: "Poppins";
  box-shadow: 0px 6px 12px 0px rgba(95, 103, 109, 0.09);
  border-radius: 4px;
  display: block;
  width: 100%;
  padding: 12px 15px;
  height: 40px;
  box-sizing: border-box;
  transition: box-shadow .25s ease-out, 
    border-color .2s;

  @media only screen and (max-width: 768px) {
    padding-left: 10px;
    padding-right: 10px;
  }

  &::placeholder,
  &::-webkit-input-placeholder, 
  :-ms-input-placeholder {
    color: rgb(47,49,56);
  }

  &:focus {
    outline: none;
    border: 1px solid #929aad;
  }
}

button {
  margin: 14px 0 0 0;
  width: 100%;
  font-size: 16px;
  font-family: "Poppins";
  text-align: center;
  height: 40px;
  padding: 0 15px;
  color: #fff;
  box-sizing: border-box;
  border-radius: 4px;
  border: 0;
  background: #2bbd7e;
  cursor: pointer;

  .spinner {
    position: relative;
    left: -20px;
    width: 20px;
    margin: 0 -20px 0 0;
  }

  &:disabled {
    cursor: default;
  }
}

.login-enter-active, .login-leave-active {
  transition: all 750ms cubic-bezier(0.230, 1.000, 0.320, 1.000);

  form {
    transition: all 750ms cubic-bezier(0.230, 1.000, 0.320, 1.000);
  }
}

.login-leave-to {
  opacity: 0;

  form {
    transform: scale(0.9);
  }
}

.login-enter {
  form {
    transform: scale(0.9);
  }
}

.fade-enter-active, .fade-leave-active {
  transition: all 250ms cubic-bezier(0.230, 1.000, 0.320, 1.000);
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>
